import React from "react";
import ObserverEmitter, { EVENTS } from "../../emitter/Observer";
import { audiosAssets } from "../../assets/audio";

export const ModalInfoPromotionV2 = ({ callback, description, title, btnText = "Continuar", url }) => {
	return (
		<div className="fixed z-30 bottom-0 h-full w-full flex justify-center items-center animate__animated  animate__fadeIn bg-[#00000074]">
			<div className="w-[396px] md:w-[640px] h-[240px] md:h-[384px] bg-[#F2F2F2] rounded-2xl p-4 md:p-6">
				<div className="h-[30px] md:h-[40px] w-full bg-red_primary flex justify-center items-center rounded">
					<p className="text-white text-[12px] font-bold">{title}</p>
				</div>
				<div className="h-[calc(100%-30px)]  md:h-[calc(100%-40px)] w-full pt-2 flex gap-2 md:gap-4">
					<div className="w-[143px] md:w-[224px] h-full rounded-md overflow-hidden ">
						<img className="h-full w-full object-contain" src={url} alt="url" />
					</div>
					<div className="w-[calc(100%-143px)] md:w-[calc(100%-224px)] h-full">
						<div className="h-[calc(100%-32px)] md:h-[calc(100%-40px)] overflow-hidden md:p-2 overflow-y-scroll hidden-scrooll">
							<p className="text-black text-[12px] md:text-[14px]">
								{description}
							</p>
						</div>
						<div onClick={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.completeNavigation)
							callback()
						}} className="boxShadowButtons h-[32px] md:h-[40px] w-full bg-yellow_primary flex justify-center items-center rounded-[10px]">
							<p className="text-white text-[12px] md:text-[14px] font-semibold">{btnText}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
